module.exports = __webpack_public_path__ + "img/2_interesting.e8b8b276.png";